var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CardContent } from "@mui/material";
import { CardOverImageTitle, CardWithShadow, EFootballSchoolStaffTypeToFriendlyName } from "@nitra/nkmb-card-components/cards";
import { useTranslation } from 'react-i18next';
export function FootballSchoolStaffDesktopCard(props) {
    var _a = props.staff, firstName = _a.firstName, lastName = _a.lastName, imageUrl = _a.imageUrl, type = _a.type;
    var i18n = useTranslation().i18n;
    return (_jsx(CardWithShadow, __assign({ cardHeightOverride: 360, fullSizeImageUrl: imageUrl, sx: {
            display: "flex",
            flexDirection: "column",
            position: "relative",
            width: "100%",
            height: "100%",
            maxWidth: 288,
            maxHeight: 360,
        }, fixedWidth: 288 }, { children: _jsxs(CardContent, __assign({ sx: { mt: "auto", zIndex: 1 } }, { children: [_jsx(CardOverImageTitle, { title: firstName, variant: "podnaslovM" }), _jsx(CardOverImageTitle, { title: lastName, variant: "podnaslovM" }), type &&
                    _jsx(CardOverImageTitle, { title: EFootballSchoolStaffTypeToFriendlyName(type, i18n.language), variant: "bodyS" })] })) })));
}
